<template>
  <div>
    <hshead title="订单详情" irregularBg="true"></hshead>
    <div class="detail-box" v-if="tempData && tempData.order">
      <!-- <div class="right-nav-btn" @click="showMenu = true">
        <img src="~@/assets/images/head/r.png" alt />
      </div> -->
      <div class="detail-h1">{{tempData.order.shootHotelName}}</div>
      <div class="detail-map">{{tempData.order.shootAddress}}</div>
      <div class="detail-line">
        <div
          v-if="tempData.order.orderStatus == 10"
          style="font-size: 0.32rem;padding: 5px;color: #c98a8a;"
        >订单已取消</div>
        <van-steps :active="active" active-color="#3cf" v-else>
          <van-step>已下单</van-step>
          <van-step>已接单</van-step>
          <van-step>{{activeStepName}}</van-step>
          <van-step>订单完成</van-step>
        </van-steps>
      </div>
      <div class="detail-block">
        <div class="this-title">
          商品信息
          <a
            href="javascript:;"
            class="href-btn darkColor"
            @click="showMenu = true"
          >订单操作</a>
        </div>
        <div class="this-img-box">
          <div class="left-img">
            <img :src="tempData.ext.imageUrl" alt />
          </div>
          <div class="center-p">
            <div class="center-p-h1">{{tempData.order.productName}}</div>
            <div class="center-p-h2">¥{{tempData.order.totalMoney.toFixed(2)}}</div>
            <div class="center-p-h3">{{tempData.ext.storeFullName}}</div>
          </div>
          <div class="right-p">×{{tempData.order.shootValue}}张</div>
        </div>
      </div>
      <div class="detail-block">
        <div class="this-title">
          订单信息-{{tempData.order.id}}
          <a
            :href="'tel:' + tempData.order.contactMobile"
            class="href-btn"
          >联系客户</a>
        </div>
        <div class="this-form-box">
          <div class="this-p-box">
            <div class="left-p">联系人:</div>
            <div class="right-p">{{tempData.order.contactName}}/{{tempData.order.contactMobile}}</div>
          </div>
          <div class="this-p-box" v-if="tempData.ext.productShootType != 1">
            <div class="left-p">预拍摄时间：</div>
            <div
              class="right-p"
            >{{tempData.order.plantStartDateing}}</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">下单日期：</div>
            <div class="right-p">{{tempData.order.createTime}}</div>
          </div>
        </div>
      </div>
      <div class="detail-block" v-if="tempData.orderTrace">
        <div class="this-title">摄影师信息</div>
        <div class="this-form-box">
          <div class="this-p-box">
            <div class="left-p">摄影师：</div>
            <div class="right-p">{{tempData.orderTrace.photoGrapherName}}</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">联系电话：</div>
            <div class="right-p">{{tempData.orderTrace.photoGrapherMobile}}</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">约拍时间：</div>
            <div
              class="right-p"
              v-if="tempData.orderTrace.plantStartDate"
            >{{tempData.orderTrace.plantStartDate}} 至 {{tempData.orderTrace.plantEndDate}}</div>
          </div>
        </div>
      </div>
      <div class="detail-block">
        <div class="this-title">备注</div>
        <div class="this-form-box">
          <div class="this-txt">{{tempData.order.buyerRemarks || '无'}}</div>
        </div>
      </div>
      <!-- <div
        class="bottom-btn-box"
        v-if="tempData.order.orderStatus > 0 && tempData.order.orderStatus < 7"
      > -->
      <div
        class="bottom-btn-box"
        v-if="false"
      >
        <a
          href="javascript:;"
          class="bottom-btn"
          @click="handleIsShow"
          v-if="tempData.order.orderStatus==1"
        >抢单设置</a>
        <a href="javascript:;" class="bottom-btn noBg" @click="handleTaskCancel">拒单</a>
        <a
          href="javascript:;"
          class="bottom-btn noBg"
          @click="handleReplaceGrapher"
          v-if="tempData.order.orderStatus <= 6"
        >派单</a>
        <a
          href="javascript:;"
          class="bottom-btn"
          @click="handleSubscribeOrder"
          v-if="tempData.order.orderStatus==2 || tempData.order.orderStatus==3"
        >预约</a>
        <template v-if="tempData.order.orderStatus==5">
          <a
            href="javascript:;"
            class="bottom-btn noBg"
            @click="handleTaskAudit(tempData.order, true)"
          >审核通过</a>
          <a
            href="javascript:;"
            class="bottom-btn noBg"
            @click="handleTaskAudit(tempData.order, false)"
          >审核不通过</a>
        </template>
      </div>
      <!-- <div class="bottom-btn-box" v-if="tempData.order.orderStatus==5">
        <a href="javascript:;" class="bottom-btn noBg" @click="handleTaskAudit(item, true)">审核通过</a>
        <a href="javascript:;" class="bottom-btn noBg" @click="handleTaskAudit(item, false)">审核不通过</a>
      </div>-->
    </div>

    <!-- 预约 -->
    <van-dialog
      v-model="dialogSubscribeOrderFormVisible"
      class="handle-dialog"
      title="预约拍摄"
      show-cancel-button
      @confirm="subscribeOrder"
      :beforeClose="beforeClose"
      style="width:100%;height:100%;top:50%;"
    >
      <br />
      <van-cell-group v-if="tempData && tempData.orderTrace">
        <van-field
          v-model="tempData.orderTrace.plantStartDate"
          label="开始日期"
          placeholder="计划拍摄开始日期"
          @click="dateFieldClick('plantStartDate', tempData.orderTrace.plantStartDate)"
          readonly
        />
        <van-field
          v-model="tempData.orderTrace.plantEndDate"
          label="结束日期"
          placeholder="计划拍摄结束日期"
          @click="dateFieldClick('plantEndDate', tempData.orderTrace.plantEndDate)"
          readonly
        />
        <van-field
          v-model="tempData.orderTrace.plantDeliveryDate"
          label="交付日期"
          placeholder="预交付日期"
          @click="dateFieldClick('plantDeliveryDate', tempData.orderTrace.plantDeliveryDate)"
          readonly
        />
      </van-cell-group>
    </van-dialog>

    <van-popup v-model="showPopup" :close-on-click-overlay="false" position="bottom">
      <van-datetime-picker
        v-model="curSelectedDate"
        type="date"
        placeholder="日期"
        @confirm="datePickerConfirm"
        @cancel="datePickerCancel"
      />
    </van-popup>

    <!-- 拒单 -->
    <van-dialog
      v-model="dialogTaskCancelFormVisible"
      title="填写取消原因"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="cancelTaskOrder"
    >
      <van-cell-group name>
        <van-field v-model="reason" type="textarea" placeholder="请输入取消原因" rows="3" autosize></van-field>
      </van-cell-group>
    </van-dialog>

    <!-- 派单 -->
    <van-dialog
      v-model="dialogReplaceGrapherFormVisible"
      title="指派摄影师"
      :beforeClose="beforeClose"
      @confirm="replaceGrapher"
      style="width:100%;height:100%;top: 50%;"
      class="replacerapher"
      @load="onLoadByGrapher"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div
        class="dialog-lshoot-close"
        @click="dialogReplaceGrapherFormVisible = !dialogReplaceGrapherFormVisible"
      >
        <van-icon name="close" size="0.7rem" />
      </div>
      <br />
      <div>
        <van-cell-group>
          <!-- <van-field
            v-model="listQueryByGrapher.photoGrapherName"
            label="名称"
            placeholder="摄影师名称"
          />
          <van-field
            v-model="listQueryByGrapher.mobile"
            label="手机"
            placeholder="手机号码"
            @focus="onFocus"
          />
          <van-number-keyboard
            v-model="listQueryByGrapher.mobile"
            :maxlength="11"
            :show="showNumberKeyboard"
            close-button-text="完成"
            theme="custom"
            @blur="showNumberKeyboard = false"
          />
          <van-cell>
            <van-button type="primary" size="small" @click="getGrapherPagerBySearch">搜索</van-button>
          </van-cell>-->
          <van-search v-model="listQueryByGrapher.photoGrapherName" placeholder="请输入摄影师名称 / 手机号码"></van-search>
        </van-cell-group>
        <div class="grapher-ul">
          <van-radio-group v-model="radioByGrapher">
            <van-list
              v-model="loadingByGrapher"
              :finished="finishedByGrapher"
              finished-text="没有更多了"
            >
              <div class="grapher-li" v-for="(item, index) in listByGrapherDynamic" :key="index">
                <div>
                  <van-radio
                    :name="item.id"
                    checked-color="#07c160"
                    @click="replaceGrapher"
                  >{{item.photoGrapherName}}（{{item.mobile}}）</van-radio>
                </div>
              </div>
              <div style="text-align:center;padding-top:10px;">
                <van-button
                  plain
                  type="primary"
                  size="small"
                  @click="getGrapherPagerByMore"
                  v-if="!finishedByGrapher"
                >点击加载更多</van-button>
              </div>
            </van-list>
          </van-radio-group>
        </div>
      </div>
    </van-dialog>

    <!-- 抢单设置 -->
    <van-dialog
      v-model="dialogIsShowFormVisible"
      title="抢单设置"
      show-cancel-button
      :beforeClose="beforeClose"
      @confirm="doHandleIsShow"
    >
      <br />
      <van-cell-group name>
        <van-field
          v-model="tempDataByIsShow.actualTotalMoney"
          label="摄影师结算价"
          input-align="right"
          placeholder="填写价格"
          type="number"
        />
        <van-cell-group>
          <van-cell title="设置公开抢单">
            <van-radio-group v-model="tempDataByIsShow.isShow">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
            </van-radio-group>
          </van-cell>
        </van-cell-group>
      </van-cell-group>
    </van-dialog>
    <van-action-sheet v-model="showMenu" cancel-text="取消" :actions="menus" @select="onSelect" />
  </div>
</template>

<script>
import {
  ActionSheet,
  Toast,
  Step,
  Steps,
  Dialog,
  CellGroup,
  Cell,
  Field,
  DatetimePicker,
  Popup,
  Icon,
  NumberKeyboard,
  RadioGroup,
  Radio,
  List,
  Button,
  Search
} from "vant";
import hshead from "@/components/common/hshead";
import moment from "moment";
import { subscribeOrder } from "@/api/m/grapher";
import {
  getTaskOrderDetail,
  cancelTaskOrder,
  getGrapherPagerByOrder,
  replaceGrapher,
  auditTaskOrder,
  modifyOrderActualTotalMoney
} from "@/api/m/store";
import { orderStatusOptions } from "@/constant/enum/order";

export default {
  name: "OrderDetail",
  data() {
    return {
      showMenu: false, // 按钮组的显示
      menus: [],
      active: 0,
      activeStepName: "已拍摄",
      orderStatusOptions,
      tempData: null,
      dialogSubscribeOrderFormVisible: false,
      //
      showPopup: false,
      curSelectedDate: new Date(),
      curClickedField: "",
      // 拒单
      dialogTaskCancelFormVisible: false,
      reason: "",
      // 指派摄影师
      showNumberKeyboard: false,
      radioByGrapher: null,
      dialogReplaceGrapherFormVisible: false,
      listByGrapher: [],
      loadingByGrapher: false,
      finishedByGrapher: false,
      listQueryByGrapher: {
        pn: 1,
        ps: 1000
      },
      // 抢单设置
      dialogIsShowFormVisible: false,
      tempDataByIsShow: { actualTotalMoney: null, isShow: null }
    };
  },
  created() {
    let { orderId } = this.$route.query;
    if (orderId) this.getTaskOrderDetail(orderId);
  },
  methods: {
    onLoadByGrapher() {
      this.getGrapherPager(0);
    },
    // 选中
    onSelect(item, index) {
      let self = this;
      self.showMenu = false; // 点击选项时默认不会关闭菜单，可以手动关闭
      console.info("item", item);
      // 判断输出
      switch (item.state) {
        case '1':
          // 抢单设置
          self.handleIsShow();
          break;

        case '2':
          // 拒单
          self.handleTaskCancel();
          break;

        case '3':
          // 派单
          self.handleReplaceGrapher();
          break;

        case '4':
          // 预约
          self.handleSubscribeOrder();
          break;

        case '5':
          // 审核通过
          self.handleTaskAudit(self.tempData.order, true);
          break;

        case '6':
          // 审核不通过
          self.handleTaskAudit(self.tempData.order, false);
          break;

        default:
          break;
      }
    },
    //列表数据
    getTaskOrderDetail(orderId) {
      let self = this;
      this.load(true, "加载中...");
      getTaskOrderDetail({ orderId: orderId })
        .then(response => {
          this.load(false);
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getTaskOrderDetail -> data", data);
            this.tempData = data;
            if (this.tempData.order.orderStatus == 1) this.active = 0;
            else if (this.tempData.order.orderStatus == 2) this.active = 1;
            else if (this.tempData.order.orderStatus == 9) this.active = 3;
            else if (this.tempData.order.orderStatus == 10) this.active = 3;
            else {
              this.active = 2;
              this.activeStepName = orderStatusOptions.filter(
                w => w.key == this.tempData.order.orderStatus
              )[0].display_name;
            }
            // 按钮组
            if (
              self.tempData.order.orderStatus > 0 &&
              self.tempData.order.orderStatus < 7
            ) {
              if (self.tempData.order.orderStatus == 1) {
                self.menus.push({
                  state: "1",
                  disabled: false,
                  name: "抢单设置"
                });
              }
              self.menus.push({
                state: "2",
                disabled: false,
                name: "拒单"
              });
              if (self.tempData.order.orderStatus <= 6) {
                self.menus.push({
                  state: "3",
                  disabled: false,
                  name: "派单"
                });
              }
              if (
                self.tempData.order.orderStatus == 2 ||
                self.tempData.order.orderStatus == 3
              ) {
                self.menus.push({
                  state: "4",
                  disabled: false,
                  name: "预约"
                });
              }
              if (self.tempData.order.orderStatus == 5) {
                self.menus.push({
                  state: "5",
                  disabled: false,
                  name: "审核通过"
                });
                self.menus.push({
                  state: "6",
                  disabled: false,
                  name: "审核不通过"
                });
              }
            }
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //取消任务
    handleTaskCancel() {
      this.dialogTaskCancelFormVisible = true;
    },
    cancelTaskOrder() {
      if (this.reason == "") {
        this.tips(`请输入取消原因`);
        return false;
      }

      this.load(true, "加载中...");
      let para = {
        ids: [this.tempData.order.id],
        reason: this.reason
      };
      cancelTaskOrder(para)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            this.dialogTaskCancelFormVisible = false;
            this.tempData.order.orderStatus = 10;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    /************* 预约相关 *************/

    dateFieldClick(field, date) {
      this.showPopup = true;
      this.curClickedField = field;
      console.info("date", date, moment(date));
      if (date)
        this.curSelectedDate = new Date(moment(date).format("YYYY-MM-DD"));
    },
    datePickerConfirm(val) {
      this.showPopup = false;
      console.info("datePickerConfirm", val, this.curClickedField);
      this.tempData.orderTrace[this.curClickedField] = moment(val).format(
        "YYYY.MM.DD"
      );
    },
    datePickerCancel() {
      this.showPopup = false;
    },
    beforeClose(action, done) {
      if (action == "cancel") done();
      else done(false);
    },
    handleSubscribeOrder() {
      this.dialogSubscribeOrderFormVisible = true;
    },
    subscribeOrder() {
      console.info("subscribeOrder", this.tempData.orderTrace);
      const {
        plantStartDate,
        plantEndDate,
        plantDeliveryDate
      } = this.tempData.orderTrace;
      if (!plantStartDate || !plantEndDate || !plantDeliveryDate) {
        this.tips("日期不能为空");
        return;
      } else {
        const param = {
          orderId: this.tempData.order.id,
          plantStartDate: this.tempData.orderTrace.plantStartDate,
          plantEndDate: this.tempData.orderTrace.plantEndDate,
          plantDeliveryDate: this.tempData.orderTrace.plantDeliveryDate
        };
        this.load(true, "加载中...");
        subscribeOrder(param)
          .then(response => {
            this.load(false);
            const { code, msg, data } = response;
            if (code >= 0) {
              this.tips(`操作成功`);
              this.dialogSubscribeOrderFormVisible = false;
              if (this.tempData.order.orderStatus == 2)
                this.tempData.order.orderStatus = 3;
            }
          })
          .catch(response => {
            this.load(false);
            //this.tips(response.msg);
            Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
          });
      }
    },
    /************* 派单（指派摄影师） *************/
    onFocus() {
      this.showNumberKeyboard = true;
    },
    //摄影师列表数据
    getGrapherPager() {
      this.listQueryByGrapher.orderId = this.tempData.order.id;
      getGrapherPagerByOrder(this.listQueryByGrapher)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getGrapherPager -> data", data);
            //
            if (data.totalRecord == 0) {
              this.loadingByGrapher = false;
              this.finishedByGrapher = true;
            } else {
              data.list.map(item => {
                this.listByGrapher.push(item);
              });
              this.listByGrapherDynamic = this.listByGrapher;
              // 加载状态结束
              this.loadingByGrapher = false;
              // 数据全部加载完成
              if (this.listByGrapher.length >= data.totalRecord) {
                this.finishedByGrapher = true;
              }
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //打开层
    handleReplaceGrapher() {
      console.info("ReplaceGrapher");
      this.dialogReplaceGrapherFormVisible = true;
      if (this.listByGrapher.length == 0) this.getGrapherPager();
    },
    //搜索
    getGrapherPagerBySearch() {
      this.listQueryByGrapher.pn = 1;
      this.listByGrapher = [];
      this.finishedByGrapher = false;
      this.getGrapherPager();
    },
    //加载更多
    getGrapherPagerByMore() {
      this.listQueryByGrapher.pn = this.listQueryByGrapher.pn + 1;
      this.getGrapherPager();
    },
    //
    replaceGrapher() {
      console.info("replaceGrapher", this.radioByGrapher);
      const grapher = this.listByGrapher.filter(
        w => w.id == this.radioByGrapher
      )[0];
      const message = `是否确认将订单\n【${this.tempData.order.productName}】\n指派给摄影师\n【${grapher.photoGrapherName}】`;
      Dialog.confirm({
        title: "确认操作",
        message: message
      })
        .then(() => {
          // on confirm
          const param = {
            Id: this.tempData.order.id,
            GrapherId: grapher.id
          };
          console.info("param", param);
          this.load(true, "加载中...");
          replaceGrapher(param)
            .then(response => {
              this.load(false);
              const { code, msg, data } = response;
              if (code >= 0) {
                this.tips(`操作成功`);
                this.dialogReplaceGrapherFormVisible = false;
              }
            })
            .catch(response => {
              this.load(false);
              //this.tips(response.msg);
              Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    /************* 审核 *************/
    handleTaskAudit(row, flag) {
      const message = `确认审核【${flag ? "通过" : "不通过"}】订单\n${
        row.productName
      }`;
      Dialog.confirm({
        title: "确认操作",
        message: message
      })
        .then(() => {
          // on confirm
          let param = { ids: [row.id], isOk: flag };
          this.load(true, "加载中...");
          auditTaskOrder(param)
            .then(response => {
              this.load(false);
              const { code, msg, data } = response;
              if (code >= 0) {
                this.tips(`操作成功`);
                if (flag) this.tempData.order.orderStatus = 7;
                else this.tempData.order.orderStatus = 6;
              }
            })
            .catch(response => {
              this.load(false);
              //this.tips(response.msg);
              Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    /************* 抢单设置 *************/
    handleIsShow() {
      console.info("handleIsShow");
      this.dialogIsShowFormVisible = true;
      this.tempDataByIsShow.actualTotalMoney = this.tempData.order.actualTotalMoney;
      this.tempDataByIsShow.isShow = `${this.tempData.order.isShow}`;
    },
    doHandleIsShow() {
      console.info("doHandleIsShow", this.tempDataByIsShow);
      let param = {
        OrderId: this.tempData.order.id,
        ActualTotalMoney: this.tempDataByIsShow.actualTotalMoney,
        IsShow: this.tempDataByIsShow.isShow
      };
      this.load(true, "加载中...");
      modifyOrderActualTotalMoney(param)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            this.dialogIsShowFormVisible = false;
            this.tempData.order.actualTotalMoney = data.actualTotalMoney;
            this.tempData.order.totalMoney = data.totalMoney;
            this.tempData.order.isShow = data.isShow;
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    }
  },
  components: {
    hshead,
    "van-steps": Steps,
    "van-step": Step,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup,
    "van-icon": Icon,
    "van-button": Button,
    "van-number-keyboard": NumberKeyboard,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-list": List,
    "van-search": Search,
    "van-action-sheet": ActionSheet
  },
  watch: {
    listQueryByGrapher: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        // let self = this;
        // self.getGrapherPagerBySearch()
        //console.info('watch', val, oldVal)
        this.listByGrapherDynamic = this.listByGrapher.filter(
          w =>
            w.photoGrapherName.indexOf(val.photoGrapherName) > -1 ||
            w.mobile.indexOf(val.photoGrapherName) > -1
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.detail-box {
  margin-top: -6.2rem;
  margin-bottom: 0.4rem;
  .detail-h1 {
    font-family: PingFang-SC-Medium;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    padding-left: 0.65rem;
    padding-bottom: 0.35rem;
  }
  .detail-map {
    font-family: PingFang-SC-Medium;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    padding-left: 1.1rem;
    line-height: 0.4rem;
    margin-bottom: 0.5rem;
    background: url(~@/assets/images/order/mapw.png) 0.62rem center no-repeat;
    background-size: 0.25rem 0.37rem;
  }
  .detail-line {
    width: 6.9rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    overflow: hidden;
  }
  .detail-block {
    width: 6.9rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .this-title {
      height: 0.83rem;
      line-height: 0.83rem;
      font-family: PingFang-SC-Medium;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #00b8f5;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 0.35rem;
      &::before {
        content: "";
        width: 0.08rem;
        height: 0.25rem;
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#000000, #000000);
        background-blend-mode: normal, normal;
        border-radius: 0.04rem;
        position: absolute;
        left: 0.15rem;
        top: 0.28rem;
      }
      .href-btn {
        position: absolute;
        width: 1.46rem;
        height: 0.46rem;
        line-height: 0.46rem;
        border-radius: 0.23rem;
        border: solid 1px #00aae5;
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #00aae5;
        top: 0.2rem;
        right: 0.2rem;
        text-align: center;
      }
      .href-btn.darkColor {
        background-color: #00aae5;
        color: #fff;
      }
    }
    .this-img-box {
      display: flex;
      padding: 0.3rem 0.28rem 0.33rem 0.26rem;
      .left-img {
        width: 2.42rem;
        height: 2.03rem;
        background-color: #000000;
        overflow: hidden;
        img {
          //width: 2.42rem;
          width: auto;
          height: 100%;
        }
      }
      .center-p {
        width: 2.8rem;
        padding-left: 0.3rem;
        .center-p-h1 {
          font-family: PingFang-SC-Bold;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.48rem;
          letter-spacing: -1px;
          color: #333333;
        }
        .center-p-h2 {
          font-family: PingFang-SC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        .center-p-h3 {
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.34rem;
          letter-spacing: 0rem;
          color: #8a9096;
        }
      }
      .right-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #00bbfb;
        text-align: right;
      }
    }
    .this-form-box {
      padding: 0.3rem;
      .this-p-box {
        display: flex;
        .left-p {
          width: 1.9rem;
          height: 0.23rem;
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.6rem;
          letter-spacing: -1px;
          color: #999999;
        }
        .right-p {
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.6rem;
          letter-spacing: -1px;
          color: #333333;
        }
      }
      .this-txt {
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.48rem;
        letter-spacing: -1px;
        color: #333333;
        word-break: break-all;
      }
    }
  }
  .bottom-btn-box {
    width: 7.5rem;
    // height: 0.98rem;
    background-color: #ffffff;
    box-shadow: 0rem -1px 0.05rem 0rem #e5e5e5;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-bottom: 0.15rem;
    .bottom-btn {
      // min-width: 20%;
      margin-top: 0.15rem;
      display: block;
      width: 2.2rem;
      height: 0.68rem;
      line-height: 0.68rem;
      background-image: linear-gradient(-89deg, #348ff5 0%, #2fa9ff 100%),
        linear-gradient(#333333, #333333);
      background-blend-mode: normal, normal;
      box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(49, 160, 252, 0.38);
      border-radius: 0.34rem;
      color: #fff;
      font-size: 0.32rem;
      text-align: center;
      &.noBg {
        color: #329bf9;
        background: transparent;
        border: 1px solid #329bf9;
      }
    }
  }
}
.van-dialog__content {
  padding-top: 10px;
}
.replacerapher .van-dialog__content {
  height: 80%;
}
.grapher-ul {
  width: 100%;
  height: 65%;
  overflow: scroll;
  position: absolute;
  .van-list {
    width: 100%;
  }
  .grapher-li {
    border: 1px solid #f0f6ef;
    padding: 0.2rem 0px;
    font-size: 0.28rem;
  }
  .van-loading {
    display: none;
  }
}
.dialog-lshoot-close {
  position: fixed;
  top: 0.2rem;
  right: 0.2rem;
  color: #ff0000;
}
.right-nav-btn {
  position: fixed;
  width: 0.38rem;
  margin-right: 0.4rem;
  margin-top: 0.25rem;
  right: 0;
  top: 0;
  z-index: 22;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store/orderDetail.vue